import { useState, useEffect } from "react";
import debounce from "lodash.debounce";

function getDivDimensions(cardRef) {
  const currentNode = cardRef?.current;
  if (!currentNode) return { width: 0, height: 0 };

  const rect = currentNode.getBoundingClientRect();
  return {
    width: Math.round(rect.width),
    height: Math.round(rect.height),
  };
}

export default function useDivDimensions(cardRef) {
  const [divDimensions, setDivDimensions] = useState(() =>
    getDivDimensions(cardRef)
  );

  useEffect(() => {
    const element = cardRef?.current;
    if (!element) return;

    const updateDimensions = () => {
      setDivDimensions(getDivDimensions(cardRef));
    };

    // Debounce to avoid ResizeObserver loop warnings
    const debouncedUpdate = debounce(updateDimensions, 50);

    const resizeObserver = new ResizeObserver(() => {
      debouncedUpdate();
    });

    resizeObserver.observe(element);

    // set initial value on mount
    updateDimensions();

    return () => {
      debouncedUpdate.cancel(); // cancel any pending calls
      resizeObserver.disconnect();
    };
  }, [cardRef]);

  return divDimensions;
}
